import { Nut } from '@phosphor-icons/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SubtitleCards } from 'core/components';
import { IPartBomDetails } from 'partBoms/types';
import { PricingHelper } from 'pricing/helpers';

interface IProps {
  partBom: IPartBomDetails;
}

export const PartBomCards = ({ partBom }: IProps) => {
  const { t } = useTranslation();

  const cards = useMemo(
    () => [
      {
        label: t('labelBomTotal'),
        icon: <Nut weight="fill" />,
        value: PricingHelper.formatPricing({
          amount: partBom?.cost,
        }),
      },
    ],
    [partBom?.cost, t]
  );

  return (
    <SubtitleCards
      cards={cards}
      options={{
        cardSx: { width: 'fit-content', minWidth: '150px' },
        layout: { useGrid: true },
      }}
    />
  );
};
